import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["accept", "buttonLabel", "classes", "className", "cropAspect", "cropImages", "cropTitle", "cropTooltip", "cropAcceptLabel", "cropCancelLabel", "disabled", "error", "files", "filesData", "hint", "id", "info", "isFullWidth", "isReadOnly", "isRequired", "label", "labelMode", "maxFiles", "maxSize", "maxVisible", "minSize", "maxHeight", "maxWidth", "minHeight", "minWidth", "multiple", "name", "onCrop", "onDrop", "onRemove", "overrides", "previewImages", "singleImagePreview", "title", "subtitle", "groups", "foldedText", "unfoldedText", "onExceedFileLimitDrop"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useMemo, useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { useDropzone } from 'react-dropzone';
import Groups from './components/Groups';
import ModalCrop from '../../general/ModalCrop';
import Icon from '../../general/Icon';
import { getOverrides, useClasses } from '../../../utils/overrides';
import Button from '../../general/Button';
import Label from '../Label';
import Text from '../../typography/Text';
import { checkBrowserCanRender } from './utils';
import { createUseStyles } from '../../../utils/styles';
import styles from './styles';
var useStyles = createUseStyles(styles, 'FilePicker');
var imageTypes = ['image/png', 'image/jpeg', 'image/webp', 'image/gif', 'image/bmp', 'image/heic'];
var imageExtensions = ['png', 'jpeg', 'jpg', 'webp', 'gif', 'bmp', 'heic'];
var _ref2 = /*#__PURE__*/React.createElement(Icon, {
  name: "img",
  size: "big"
});
function FilePicker(_ref) {
  var _classnames, _classnames2;
  var accept = _ref.accept,
    buttonLabel = _ref.buttonLabel,
    classesProp = _ref.classes,
    classNameProp = _ref.className,
    cropAspect = _ref.cropAspect,
    cropImages = _ref.cropImages,
    cropTitle = _ref.cropTitle,
    cropTooltip = _ref.cropTooltip,
    cropAcceptLabel = _ref.cropAcceptLabel,
    cropCancelLabel = _ref.cropCancelLabel,
    disabled = _ref.disabled,
    error = _ref.error,
    files = _ref.files,
    filesData = _ref.filesData,
    hint = _ref.hint,
    id = _ref.id,
    info = _ref.info,
    isFullWidth = _ref.isFullWidth,
    isReadOnly = _ref.isReadOnly,
    isRequired = _ref.isRequired,
    label = _ref.label,
    labelMode = _ref.labelMode,
    maxFiles = _ref.maxFiles,
    maxSize = _ref.maxSize,
    maxVisible = _ref.maxVisible,
    minSize = _ref.minSize,
    maxHeight = _ref.maxHeight,
    maxWidth = _ref.maxWidth,
    minHeight = _ref.minHeight,
    minWidth = _ref.minWidth,
    multiple = _ref.multiple,
    name = _ref.name,
    onCrop = _ref.onCrop,
    onDrop = _ref.onDrop,
    onRemove = _ref.onRemove,
    overridesProp = _ref.overrides,
    previewImages = _ref.previewImages,
    singleImagePreview = _ref.singleImagePreview,
    title = _ref.title,
    subtitle = _ref.subtitle,
    groups = _ref.groups,
    foldedText = _ref.foldedText,
    unfoldedText = _ref.unfoldedText,
    onExceedFileLimitDrop = _ref.onExceedFileLimitDrop,
    props = _objectWithoutProperties(_ref, _excluded);
  var classes = useClasses(useStyles, classesProp);
  var _useState = useState({
      isOpen: false,
      file: null
    }),
    _useState2 = _slicedToArray(_useState, 2),
    crop = _useState2[0],
    setCrop = _useState2[1];
  var _useState3 = useState(0),
    _useState4 = _slicedToArray(_useState3, 2),
    totalDroppedTooltip = _useState4[0],
    setTotalDroppedTooltip = _useState4[1];
  var _useState5 = useState({}),
    _useState6 = _slicedToArray(_useState5, 2),
    totalDroppedByGroupTooltip = _useState6[0],
    setTotalDroppedByGroupTooltip = _useState6[1];
  var handleOnDrop = useCallback(function (droppedFiles) {
    var tempDroppedByGroup = {};
    if (groups !== null && groups !== void 0 && groups.length) {
      var isExceededList = groups.reduce(function (arr, group, index) {
        if (!group.maxFiles || !group.validateFiles) return arr;
        var selectedFiles = [];
        var selectedDroppedFiles = droppedFiles.filter(function (file) {
          return group.validateFiles(file);
        });
        tempDroppedByGroup[index] = selectedDroppedFiles;
        if (selectedDroppedFiles.length) {
          selectedFiles = (files === null || files === void 0 ? void 0 : files.filter(function (file) {
            return group.validateFiles(file);
          })) || [];
          var isExceeded = [].concat(_toConsumableArray(selectedFiles), _toConsumableArray(selectedDroppedFiles)).length > group.maxFiles;
          arr.push(isExceeded);
        }
        return arr;
      }, []);
      if (isExceededList !== null && isExceededList !== void 0 && isExceededList.length) {
        var isExceeded = isExceededList.some(function (current) {
          return current === true;
        });
        if (isExceeded) {
          onExceedFileLimitDrop && onExceedFileLimitDrop(droppedFiles);
          return;
        }
      }
    } else if (maxFiles) {
      var _isExceeded = ((files === null || files === void 0 ? void 0 : files.length) || 0) + ((droppedFiles === null || droppedFiles === void 0 ? void 0 : droppedFiles.length) || 0) > maxFiles;
      if (_isExceeded) {
        onExceedFileLimitDrop && onExceedFileLimitDrop(droppedFiles);
        return;
      }
    }
    if (cropImages && onCrop && cropAspect && droppedFiles.length === 1 && imageTypes.includes(droppedFiles[0].type)) {
      return setCrop({
        isOpen: true,
        file: droppedFiles[0],
        index: -1
      });
    }
    return onDrop && Promise.resolve(onDrop(droppedFiles.map(function (file) {
      return _extends(file, {
        id: Date.now()
      });
    }))).then(function (result) {
      if (groups) {
        var newGroupTooltips = groups.reduce(function (obj, group, index) {
          var _tempDroppedByGroup$i;
          if (group.maxVisible && tempDroppedByGroup !== null && tempDroppedByGroup !== void 0 && (_tempDroppedByGroup$i = tempDroppedByGroup[index]) !== null && _tempDroppedByGroup$i !== void 0 && _tempDroppedByGroup$i.length) {
            obj[index] = tempDroppedByGroup[index].length;
          }
          return obj;
        }, {});
        setTotalDroppedByGroupTooltip(newGroupTooltips);
        setTimeout(function () {
          setTotalDroppedByGroupTooltip({});
        }, 2500);
      } else if (maxVisible) {
        setTotalDroppedTooltip(droppedFiles.length);
        setTimeout(function () {
          setTotalDroppedTooltip(0);
        }, 2500);
      }
    });
  }, [cropAspect, cropImages, onCrop, onDrop, groups, maxVisible, files, maxFiles, onExceedFileLimitDrop]);
  var handleOnCrop = useCallback(function (file, index, id) {
    setCrop({
      isOpen: true,
      file: file,
      index: index,
      id: id
    });
  }, []);
  var handleOnCancelCrop = useCallback(function () {
    setCrop(_objectSpread(_objectSpread({}, crop), {}, {
      isOpen: false
    }));
  }, [crop]);
  var handleOnAcceptCrop = useCallback(function (file) {
    var newFile = crop.id ? {
      id: crop.id,
      file: file
    } : file;
    crop.index === -1 ? onDrop && onDrop([file]) : onCrop && onCrop(newFile, crop.index);
    setCrop(_objectSpread(_objectSpread({}, crop), {}, {
      isOpen: false
    }));
  }, [crop, onCrop, onDrop]);
  var _useDropzone = useDropzone(_objectSpread(_objectSpread({
      onDrop: handleOnDrop,
      accept: accept ? accept.reduce(function (fileTypes, fileType) {
        fileTypes[fileType] = [];
        return fileTypes;
      }, {}) : {},
      disabled: disabled,
      maxSize: maxSize,
      minSize: minSize,
      multiple: multiple && !cropAspect
    }, props), {}, {
      noClick: true,
      noKeyboard: true
    })),
    getRootProps = _useDropzone.getRootProps,
    getInputProps = _useDropzone.getInputProps,
    isDragActive = _useDropzone.isDragActive,
    open = _useDropzone.open;

  // Overrides
  var override = getOverrides(overridesProp, FilePicker.overrides);

  // Classes
  var rootClassName = classnames(classes.root, (_classnames = {}, _defineProperty(_classnames, classes.isReadOnly, isReadOnly), _defineProperty(_classnames, classes[labelMode], labelMode), _defineProperty(_classnames, classes.isFullWidth, isFullWidth), _defineProperty(_classnames, classes.errored, error), _classnames), classNameProp);
  var dropZoneClassName = classnames(classes.dropZone, (_classnames2 = {}, _defineProperty(_classnames2, classes.isDragActive, isDragActive), _defineProperty(_classnames2, classes.disabled, disabled), _classnames2), classNameProp);
  var rootProps = {
    className: rootClassName
  };
  var labelProps = _objectSpread({
    className: classes.Label,
    isRequired: isRequired,
    hint: hint
  }, override.Label);
  var showDragzone = useMemo(function () {
    return !(!groups && maxFiles && files.length >= maxFiles);
  }, [files.length, maxFiles, groups]);
  var renderSingleImagePreview = useMemo(function () {
    var _files$, _files$2;
    if (maxFiles !== 1 || !singleImagePreview || showDragzone) return;
    var newFile = null;
    if ((_files$ = files[0]) !== null && _files$ !== void 0 && _files$.file) newFile = (_files$2 = files[0]) === null || _files$2 === void 0 ? void 0 : _files$2.file;else newFile = files[0];
    var isUrl = typeof newFile === 'string';
    var canRender = checkBrowserCanRender(isUrl ? newFile : newFile.name);
    return /*#__PURE__*/React.createElement("div", {
      className: classes.singleImagePreview
    }, canRender && /*#__PURE__*/React.createElement("span", {
      style: {
        backgroundImage: "url(\"".concat(isUrl ? newFile : URL.createObjectURL(newFile), "\")")
      }
    }), !canRender && _ref2);
  }, [classes.singleImagePreview, files, maxFiles, showDragzone, singleImagePreview]);
  var filePickerProps = _objectSpread({
    id: id,
    name: name,
    className: classes.input
  }, override.input);
  return /*#__PURE__*/React.createElement("div", _extends({}, rootProps, override.root), label && /*#__PURE__*/React.createElement(Label, labelProps, label), /*#__PURE__*/React.createElement("div", _extends({
    className: classes.formControl
  }, override.formControl), renderSingleImagePreview, showDragzone && /*#__PURE__*/React.createElement("div", _extends({
    className: dropZoneClassName
  }, getRootProps()), /*#__PURE__*/React.createElement("input", _extends({}, getInputProps(), filePickerProps)), /*#__PURE__*/React.createElement(Text, {
    type: "subtitle",
    className: classes.title
  }, title), /*#__PURE__*/React.createElement(Text, {
    type: "caption",
    className: classes.subtitle
  }, subtitle), /*#__PURE__*/React.createElement(Button, {
    className: classes.button,
    type: "secondary",
    onClick: open
  }, buttonLabel)), /*#__PURE__*/React.createElement(Groups, {
    classes: classes,
    classesProp: classesProp,
    overrides: override,
    files: files,
    imageTypes: imageTypes,
    imageExtensions: imageExtensions,
    previewImages: previewImages,
    cropImages: cropImages,
    cropTooltip: cropTooltip,
    handleOnCrop: handleOnCrop,
    onRemove: onRemove,
    filesData: filesData,
    groups: groups,
    foldedText: foldedText,
    unfoldedText: unfoldedText,
    maxVisible: maxVisible,
    maxFiles: maxFiles,
    totalDroppedTooltip: totalDroppedTooltip,
    totalDroppedByGroupTooltip: totalDroppedByGroupTooltip
  }), info && /*#__PURE__*/React.createElement("div", _extends({
    className: classes.info
  }, override.info), info), error && /*#__PURE__*/React.createElement("div", _extends({
    className: classes.error
  }, override.error), error)), /*#__PURE__*/React.createElement(ModalCrop, {
    aspect: cropAspect,
    classes: classesProp,
    file: crop.file,
    isOpen: crop.isOpen,
    onAccept: handleOnAcceptCrop,
    onCancel: handleOnCancelCrop,
    confirmText: cropAcceptLabel,
    cancelText: cropCancelLabel,
    overrides: overridesProp,
    title: cropTitle
  }));
}
FilePicker.overrides = ['root', 'filePicker', 'error', 'info', 'formControl', 'Label', 'groups', 'groupsHeader', 'groupsTitle', 'file', 'filesList'];
FilePicker.defaultProps = {
  labelMode: 'vertical',
  onDrop: function onDrop() {},
  files: [],
  isReadOnly: false,
  overrides: {},
  title: 'Drop files here',
  buttonLabel: 'Select file',
  cropTitle: 'Crop image',
  cropTooltip: 'Crop image',
  cropAcceptLabel: 'Crop',
  cropCancelLabel: 'Cancel',
  previewImages: false
};
process.env.NODE_ENV !== "production" ? FilePicker.propTypes = {
  /** Set accepted file types */
  accept: PropTypes.array,
  activePlaceholder: PropTypes.string,
  buttonLabel: PropTypes.string,
  classes: PropTypes.object,
  className: PropTypes.string,
  cropAspect: PropTypes.number,
  cropImages: PropTypes.bool,
  cropAcceptLabel: PropTypes.string,
  cropCancelLabel: PropTypes.string,
  cropTitle: PropTypes.string,
  cropTooltip: PropTypes.string,
  disabled: PropTypes.bool,
  /** Error will be displayed below the component with style changes */
  error: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  files: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.any, PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    file: PropTypes.object
  })])),
  filesData: PropTypes.object,
  /** Info popover */
  hint: PropTypes.string,
  /** Native filePicker id */
  id: PropTypes.string,
  /** Info will be displayed below the component with style changes */
  info: PropTypes.string,
  isFullWidth: PropTypes.bool,
  isReadOnly: PropTypes.bool,
  isRequired: PropTypes.bool,
  label: PropTypes.string,
  labelMode: PropTypes.oneOf(['horizontal', 'vertical']),
  /** Maximum accepted number of files The default value is 0 which means there is no limitation to how many files are accepted. */
  maxFiles: PropTypes.number,
  /** Maximum file size (in bytes) */
  maxSize: PropTypes.number,
  /** Minimum file size (in bytes) */
  minSize: PropTypes.number,
  /** Maximum image height (in pixels) */
  maxHeight: PropTypes.number,
  /** Maximum image width (in pixels) */
  maxWidth: PropTypes.number,
  /** Minimum image height (in pixels) */
  minHeight: PropTypes.number,
  /** Minimum image width (in pixels) */
  minWidth: PropTypes.number,
  multiple: PropTypes.bool,
  /** Native filePicker name */
  name: PropTypes.string,
  onCrop: PropTypes.func,
  /** For a better behaviour use a Promise. Cb for when the drop event occurs. Note that this callback is invoked after the getFilesFromEvent callback is done. */
  onDrop: PropTypes.func,
  /** For a better behaviour use a Promise */
  onRemove: PropTypes.func,
  overrides: PropTypes.object,
  title: PropTypes.string,
  /** Additional info for size limits, accepted file types and others */
  subtitle: PropTypes.string,
  previewImages: PropTypes.bool,
  groups: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string,
    maxFiles: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    validateFiles: PropTypes.func
  })),
  /** If maxVisible is true you need to provide foldedText/unfoldedText */
  maxVisible: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  foldedText: PropTypes.string,
  unfoldedText: PropTypes.string,
  /** Callback triggered when dropped files exceed the maxFiles*/
  onExceedFileLimitDrop: PropTypes.func
} : void 0;
export default /*#__PURE__*/React.memo(FilePicker);